export const LIGHTSPEED_PATHS = {
    prefill: '/mortgage/lightspeed/prefill',
    partners: '/mortgage/lightspeed/partners',
};

const DEFAULT_LIGHTSPEED_ORIGIN = 'https://lightspeed.partner-testing.lwreng.com';

export function joinLightspeedUrl(origin, path) {
    return `${String(origin || DEFAULT_LIGHTSPEED_ORIGIN).replace(/\/$/, '')}${path}`;
}
